import objectParser from '../utils/object-parser';

class Portfolio {
  constructor(items) {
    this.items = items;
    this.currentIndex = null;
    this.modal = null;
    this.data = [];
    
    this.handleControlClick = this.handleControlClick.bind(this);
    this.handleItemClick = this.handleItemClick.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);

    this.init();
  }

  init() {
    const template = document.querySelector('#template-modal');

    if(!template) return;

    this.modal = template.content.cloneNode(true).firstElementChild;
    this.modalControls = Array.from(this.modal.querySelectorAll('[data-action]'));
    
    document.body.appendChild(this.modal);

    this.modalControls.forEach((btn) => {
      btn.addEventListener('click', this.handleControlClick);
    });

    this.items.forEach((item, index) => {
      const { properties } = objectParser(item.dataset);
      this.data.push( properties ); 
      item.addEventListener('click', this.handleItemClick.bind(null, index));
    });
  }

  handleControlClick(e) {
    const { action } = e.currentTarget.dataset;
        
    switch(action) {
      case 'close':
        this.hideModal();
        break;
      case 'prev':
        this.prev();
        break;
      case 'next':
        this.next();
        break;
    }
  }

  handleItemClick(index, e) {
    e.preventDefault();

    this.setModalContent(index);
    this.currentIndex = index;
    this.showModal();
  }

  handleDocumentClick(e) {
    if (e.target === this.modal) {
      this.hideModal();
    }
  }

  showModal() {
    this.modal.showModal();
    document.body.classList.add('has-overlay');
    document.addEventListener('click', this.handleDocumentClick);
  }

  hideModal() {
    this.modal.close();
    document.body.classList.remove('has-overlay');
    this.currentIndex = null;
    document.removeEventListener('click', this.handleDocumentClick);
  }

  setModalContent(index) {
    const fields = this.modal.querySelectorAll('[data-key]');
    const props = this.data[index];
  
    fields.forEach(field => {
      const { key } = field.dataset;
      const value = props[key];
  
      if( value ) {
        if(key === 'url') {
          field.href = value;
        } else if ( key === 'image' ) {
          field.src = value.src || '';
          field.srcset = value.srcset || '';
          field.alt = value.alt || '';
        } else {
          field.innerText = value;
        }
  
        field.removeAttribute('hidden');
      } else {
        field.setAttribute('hidden', 'hidden');
      }
    });
  }
  
  prev() {
    if( this.currentIndex === 0 ) {
      this.currentIndex = this.data.length - 1;
    } else {
      this.currentIndex = this.currentIndex - 1;
    }
  
    this.setModalContent(this.currentIndex);
  }
  
  next() {
    if( this.currentIndex === this.data.length - 1 ) {
      this.currentIndex = 0;
    } else {
      this.currentIndex++;
    }
  
    this.setModalContent(this.currentIndex);
  }
  
}

const items = Array.from(document.querySelectorAll('.js-PortfolioLink'));

if(items.length) {
  new Portfolio(items);
}

